export default __webpack_public_path__ + "static/media/IND as.ef70a516.png";